import type { ICurrency } from '~/types'

export function useCurrencyFormat(
  value: number | string | null | undefined,
  currencyId: number,
  symbol: boolean = true
): string | null {
  // A missing value is not zero: return null so callers can render a placeholder.
  // A real 0 is still formatted normally.
  if (value === null || value === undefined || value === '') {
    return null
  }

  const safeValue = typeof value === 'string' ? parseFloat(value) : value

  if (typeof safeValue !== 'number' || isNaN(safeValue)) {
    return null
  }

  // Handle edge cases for currencyId
  const safeCurrencyId = typeof currencyId === 'number' ? currencyId : 1

  const currency = useCurrencyStore().list.find((i) => i.id === safeCurrencyId) as ICurrency

  // Fallback if currency not found
  if (!currency) {
    return safeValue.toFixed(2)
  }

  const {
    symbol: currencySymbol,
    formatting_dec_point,
    formatting_thousands_sep,
    formatting_decimals,
    formatting_space
  } = currency

  const fixed = safeValue.toFixed(formatting_decimals)
  const [integerPart, decimalPart] = fixed.split('.')

  const withThousands = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, formatting_thousands_sep)

  const formattedNumber =
    formatting_decimals > 0
      ? `${withThousands}${formatting_dec_point}${decimalPart}`
      : withThousands

  if (!symbol) {
    return formattedNumber
  }

  return formatting_space === 'after'
    ? `${formattedNumber} ${currencySymbol}`
    : `${currencySymbol} ${formattedNumber}`
}
